import React from 'react';
import { TypographyH3 } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import { useNotificationContext } from '@/Context/NotificationContext';
import CopyLinkControl from '../../Components/CopyLinkControl';

function Header(): React.JSX.Element {
    const { openLink } = useInviteCandidateContext();
    const { showSuccessToaster } = useNotificationContext();

    const copyHandler = async () => {
        await navigator.clipboard.writeText(openLink);
        showSuccessToaster('', UIStrings.YourRecruitmentLinkCopied);
    };

    return (
        <div className="flex flex-col gap-2">
            <TypographyH3 className="py-2.5">{UIStrings.InvitationLink}</TypographyH3>
            <CopyLinkControl link={openLink} onClickHandler={copyHandler} />
        </div>
    );
}

export default Header;
